import { AutoMap } from "@automapper/classes"
import { BaseDOM } from "../base.dom"

export class Reprise extends BaseDOM<Reprise> {

    @AutoMap()
    /** Really needed to delete Reprise as it's only managed in the client */
    Id?: number;

    @AutoMap()
    Code: string = ''
    @AutoMap()
    Longueur?: number
    @AutoMap()
    Largeur?: number
    @AutoMap()
    Surface?: number
    @AutoMap()
    Vitesse?: number

    // public constructor(init?: Partial<Reprise>) {
    //     Object.assign(this, init);
    // }
}